// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const Service = () => {
//   const [services, setServices] = useState([]);
//   const [filterType, setFilterType] = useState("all");
//   const [displayedServices, setDisplayedServices] = useState([]);
//   const [showForm, setShowForm] = useState(false);

//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     price: "",
//     image: null,
  
//   });


//   const fetchServices = () => {
//     axios
//       .post("https://gantasoft.in/cab-g/dev/admin/getserviceslist.php")
//       .then((res) => {
//         const result = Array.isArray(res.data) ? res.data : [];
//         setServices(result);
//               // console.log(res.data.data)
//       })
//       .catch((err) => {
//         console.error("Error fetching services", err);
//         setServices([]);
//       });
   
//   };


//   useEffect(() => {
//     fetchServices();
//   }, []);


//   useEffect(() => {
//     const filtered =
//       filterType === "all"
//         ? services
//         : services.filter((s) => s.type === filterType);
//     setDisplayedServices(filtered);
//   }, [filterType, services]);


//   const handleFilterClick = (type) => {
//     setFilterType(type);
//     setShowForm(type === "city" || type === "district");
//   };

  
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleFileChange = (e) => {
//     setFormData((prev) => ({ ...prev, image: e.target.files[0] }));
//   };

 
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const sendData = new FormData();
//     sendData.append("title", formData.title);
//     sendData.append("description", formData.description);
//     sendData.append("price", formData.price);
//     sendData.append("type", filterType);
//     sendData.append("image", formData.image);

//     axios
//       .post("https://gantasoft.in/cab-g/dev/admin/addservice.php", sendData)
//       .then((res) => {
//         alert(res.data.message || "Service added successfully!");
//         setFormData({
//           title: "",
//           description: "",
//           price: "",
//           image: null,
//         });
//         setShowForm(false);
//         fetchServices(); 
//       })
//       .catch((error) => {
//         console.error("Error adding service:", error);
//         alert("Error adding service");
//       });
//   };

//   return (
//     <div className="p-6 bg-gray-100 min-h-screen pt-20">
//       <h2 className="text-xl font-bold border-l-4 border-green-600 pl-3 mb-6 text-green-700">
//         Services
//       </h2>

      
//       <div className="flex gap-4 mb-6">
//         {["all", "city", "district"].map((type) => (
//           <button
//             key={type}
//             onClick={() => handleFilterClick(type)}
//             className={`px-4 py-2 rounded-md border font-medium ${
//               filterType === type
//                 ? "bg-green-600 text-white"
//                 : "bg-white text-gray-700 hover:bg-gray-100"
//             }`}
//           >
//             {type.charAt(0).toUpperCase() + type.slice(1)}
//           </button>
//         ))}
//       </div> 

//       {/* Form */}
//       {showForm && (
//         <div className="max-w-xl mx-auto mb-8 bg-white shadow-lg p-6 rounded-xl">
//           <h3 className="text-xl font-bold mb-4 text-center">
//             {filterType === "city"
//               ? "City Service Form"
//               : "District Service Form"}
//           </h3>
//           <form onSubmit={handleSubmit} className="space-y-4">
//             <input
//               type="text"
//               name="title"
//               value={formData.title}
//               onChange={handleChange}
//               required
//               placeholder="Service Title"
//               className="w-full border p-2 rounded"
//             />

//             <textarea
//               name="description"
//               value={formData.description}
//               onChange={handleChange}
//               required
//               placeholder="Service Description"
//               className="w-full border p-2 rounded"
//             ></textarea>

//             <input
//               type="number"
//               name="price"
//               value={formData.price}
//               onChange={handleChange}
//               required
//               placeholder="Service Price"
//               className="w-full border p-2 rounded"
//             />

//             <input
//               type="file"
//               name="image"
//               onChange={handleFileChange}
//               required
//               className="w-full"
//             />

//             <button
//               type="submit"
//               className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
//             >
//               Submit
//             </button>
//           </form>
//         </div>
//       )}

   
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
//         {Array.isArray(displayedServices) && displayedServices.length > 0 ? (
//           displayedServices.map((service, i) => (
//             <div
//               key={i}
//               className="flex flex-col items-center border rounded-xl p-5 bg-white shadow-md hover:shadow-xl transition"
//             >
//               <img
//                 src={"http://gantasoft.in/cab-g/dev/admin/uploads/"+ service.image || service.image } 
//                 alt={service.title}
//                 className="w-20 h-20 object-contain mb-3"
//               />
//               <h4 className="font-medium text-center text-sm text-gray-800">
//                 {service.title || service.name}
//               </h4>
//               <p className="text-xs text-gray-500">{service.type}</p>
//             </div>
//           ))
//         ) : (
//           <p className="text-gray-500 col-span-full text-center">
//             No services found.
//           </p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Service;


// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const Service = () => {
//   const [offers, setOffers] = useState([]);
//   const [filteredOffers, setFilteredOffers] = useState([]);
//   const [filterType, setFilterType] = useState("all");

//   const [showForm, setShowForm] = useState(false);
//   const [feedback, setFeedback] = useState("");

//   const [formData, setFormData] = useState({
//     title: "",
//     description: "",
//     price: "",
//     image: null,
//     type: "", // city or district
//   });

//   const cardColors = [
//   "bg-green-200",
//   "bg-blue-200",
//   "bg-yellow-200",
//   "bg-pink-200",
//   "bg-purple-200",
//   "bg-orange-200",
// ];


//   const fetchOffers = () => {
//     axios
//       .post("")
//       .then((response) => {
//         setOffers(response.data);
//         setFilteredOffers(response.data);
//       })
//       .catch((error) => console.error("Error fetching offers:", error));
//   };

//   useEffect(() => {
//     fetchOffers();
//   }, []);

//   const handleFilterClick = (type) => {
//     setFilterType(type);
//     if (type === "all") {
//       setFilteredOffers(offers);
//     } else {
//       const filtered = offers.filter((offer) => offer.type === type);
//       setFilteredOffers(filtered);
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleImageChange = (e) => {
//     setFormData((prev) => ({ ...prev, image: e.target.files[0] }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const emptyField = Object.entries(formData).some(([key, val]) => {
//       if (key === "image") return !val;
//       return val === "";
//     });
//     if (emptyField) return setFeedback("All fields are required");

//     const sendData = new FormData();
//     Object.entries(formData).forEach(([key, val]) => {
//       sendData.append(key, val);
//     });

//     axios
//       .post("", sendData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       })
//       .then(() => {
//         setFeedback("Offer submitted successfully");
//         setFormData({
//           title: "",
//           description: "",
//           price: "",
//           image: null,
//           type: "",
//         });
//         setShowForm(false);
//         fetchOffers();
//       })
//       .catch(() => setFeedback("Error submitting offer"));
//   };

//   return (
//     <div className="mx-auto px-4 py-10">
//       <button
//         onClick={() => setShowForm(true)}
//         className="bg-green-600 hover:bg-green-700 text-white font-semibold px-5 py-2 rounded-lg shadow"
//       >
//         + Add Services
//       </button>

//       {/* Filter Buttons */}
//       <div className="flex gap-4 mt-6 mb-8">
//         {["all", "city", "district"].map((type) => (
//           <button
//             key={type}
//             onClick={() => handleFilterClick(type)}
//             className={`px-4 py-2 rounded ${
//               filterType === type
//                 ? "bg-green-700 text-white"
//                 : "bg-gray-200 text-black"
//             }`}
//           >
//             {type.charAt(0).toUpperCase() + type.slice(1)}
//           </button>
//         ))}
//       </div>

//       {/* Add Offer Modal */}
//       {showForm && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg w-full max-w-lg relative shadow-lg">
//             <button
//               onClick={() => setShowForm(false)}
//               className="absolute top-2 right-3 text-2xl text-gray-500 hover:text-red-600"
//             >
//               &times;
//             </button>
//             <h2 className="text-xl font-bold mb-4 text-green-700">
//               Add New Offer
//             </h2>
//             {feedback && (
//               <p className="text-sm mb-2 text-blue-500">{feedback}</p>
//             )}
//             <form onSubmit={handleSubmit} className="space-y-3">
//               <input
//                 name="title"
//                 placeholder="Title"
//                 value={formData.title}
//                 onChange={handleChange}
//                 className="w-full p-3 border rounded-md"
//               />
//               <input
//                 name="description"
//                 placeholder="Description"
//                 value={formData.description}
//                 onChange={handleChange}
//                 className="w-full p-3 border rounded-md"
//               />
//               <input
//                 name="price"
//                 type="number"
//                 placeholder="Price"
//                 value={formData.price}
//                 onChange={handleChange}
//                 className="w-full p-3 border rounded-md"
//               />
//               <select
//                 name="type"
//                 value={formData.type}
//                 onChange={handleChange}
//                 className="w-full p-3 border rounded-md"
//               >
//                 <option value="">Select Type</option>
//                 <option value="city">City</option>
//                 <option value="district">District</option>
//               </select>
//               <input
//                 type="file"
//                 accept="image/*"
//                 onChange={handleImageChange}
//                 className="w-full p-3 border rounded-md"
//               />
//               {formData.image && (
//                 <p className="text-sm text-gray-500">
//                   Selected: {formData.image.name}
//                 </p>
//               )}
//               <button
//                 type="submit"
//                 className="w-full bg-green-600 text-white py-2 rounded-md hover:bg-green-700"
//               >
//                 Submit Offer
//               </button>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* Filtered Offers List */}
//       <h3 className="text-2xl font-semibold mt-10 mb-6 text-left text-gray-800">
//         {filterType === "all"
//           ? "All Offers"
//           : `Filtered Offers: ${filterType.toUpperCase()}`}
//       </h3>

//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
//         {filteredOffers.map((offer, index) => (
//            <div
//       key={index}
//       className={`rounded-2xl border border-gray-300 p-6 shadow-lg hover:shadow-xl hover:scale-[1.03] transition-all duration-300 ${cardColors[index % cardColors.length]}`}
//     >
//              {offer.image && (
//                       <div className="flex justify-center mb-4">

//                   <img
//                     src={"" + offer.image || offer.image}
//                      alt={offer.title}
//             className="w-24 h-24 object-contain rounded-full border"
//                   />
//                </div>
//               )}
//             <h4 className="text-2xl font-extrabold mb-3 truncate">
//               {offer.title || "Untitled Offer"}
//             </h4>
//             <ul className="space-y-1 text-base">
//               <li>
//                 <strong>Description:</strong> {offer.description}
//               </li>
//               <li>
//                 <strong>Price:</strong> ₹{offer.price}
//               </li>
//               <li>
//                 <strong>Type:</strong> {offer.type}
//               </li>
             
//             </ul>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Service;


import React, { useState, useEffect } from "react";
import axios from "axios";

const Service = () => {
  const [offers, setOffers] = useState([]);
  const [filteredOffers, setFilteredOffers] = useState([]);
  const [filterType, setFilterType] = useState("all");

  const [showForm, setShowForm] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [selectedOffer, setSelectedOffer] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    price: "",
    image: null,
    type: "",
  });

  const cardColors = [
    "bg-green-200",
    "bg-blue-200",
    "bg-yellow-200",
    "bg-pink-200",
    "bg-purple-200",
    "bg-orange-200",
  ];

  const fetchOffers = () => {
    axios
      .post("https://gantasoft.in/cab-g/dev/admin/getserviceslist.php") // Replace with your GET API
      .then((response) => {
        setOffers(response.data);
        setFilteredOffers(response.data);
      })
      .catch((error) => console.error("Error fetching offers:", error));
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  const handleFilterClick = (type) => {
    setFilterType(type);
    if (type === "all") {
      setFilteredOffers(offers);
    } else {
      const filtered = offers.filter((offer) => offer.type === type);
      setFilteredOffers(filtered);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    setFormData((prev) => ({ ...prev, image: e.target.files[0] }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const emptyField = Object.entries(formData).some(([key, val]) => {
      if (key === "image" && !selectedOffer) return !val;
      return val === "";
    });
    if (emptyField) return setFeedback("All fields are required");

    const sendData = new FormData();
    Object.entries(formData).forEach(([key, val]) => {
      sendData.append(key, val);
    });

    if (selectedOffer) {
      sendData.append("id", selectedOffer.id); // Assuming your backend uses `id`
      axios
        .post(" https://gantasoft.in/cab-g/dev/admin/update_service.php", sendData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          setFeedback("Offer updated successfully");
          resetForm();
          fetchOffers();
        })
        .catch(() => setFeedback("Error updating offer"));
    } else {
      axios
        .post("https://gantasoft.in/cab-g/dev/admin/addservice.php", sendData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          setFeedback("Offer submitted successfully");
          resetForm();
          fetchOffers();
        })
        .catch(() => setFeedback("Error submitting offer"));
    }
  };

  const resetForm = () => {
    setFormData({
      title: "",
      description: "",
      price: "",
      image: null,
      type: "",
    });
    setSelectedOffer(null);
    setShowForm(false);
  };

  const handleEdit = (offer) => {
    setSelectedOffer(offer);
    setFormData({
      title: offer.title,
      description: offer.description,
      price: offer.price,
      image: null,
      type: offer.type,
    });
    setShowForm(true);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Are you sure to delete this offer?")) return;
    axios
      .post(" https://gantasoft.in/cab-g/dev/admin/deleteservice.php", { id }) // Update API path
      .then(() => {
        fetchOffers();
      })
      .catch((err) => {
        console.error("Delete failed:", err);
        alert("Failed to delete");
      });
  };

  return (
    <div className="mx-auto px-4 py-10">
      <button
        onClick={() => {
          resetForm();
          setShowForm(true);
        }}
        className="bg-green-600 hover:bg-green-700 text-white font-semibold px-5 py-2 rounded-lg shadow"
      >
        + Add Services
      </button>

      {/* Filter Buttons */}
      <div className="flex gap-4 mt-6 mb-8">
        {["all", "city", "district"].map((type) => (
          <button
            key={type}
            onClick={() => handleFilterClick(type)}
            className={`px-4 py-2 rounded ${
              filterType === type
                ? "bg-green-700 text-white"
                : "bg-gray-200 text-black"
            }`}
          >
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </button>
        ))}
      </div>

      {/* Add / Edit Offer Modal */}
      {showForm && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-lg relative shadow-lg">
            <button
              onClick={resetForm}
              className="absolute top-2 right-3 text-2xl text-gray-500 hover:text-red-600"
            >
              &times;
            </button>
            <h2 className="text-xl font-bold mb-4 text-green-700">
              {selectedOffer ? "Edit Offer" : "Add New Offer"}
            </h2>
            {feedback && (
              <p className="text-sm mb-2 text-blue-500">{feedback}</p>
            )}
            <form onSubmit={handleSubmit} className="space-y-3">
              <input
                name="title"
                placeholder="Title"
                value={formData.title}
                onChange={handleChange}
                className="w-full p-3 border rounded-md"
              />
              <input
                name="description"
                placeholder="Description"
                value={formData.description}
                onChange={handleChange}
                className="w-full p-3 border rounded-md"
              />
              <input
                name="price"
                type="number"
                placeholder="Price"
                value={formData.price}
                onChange={handleChange}
                className="w-full p-3 border rounded-md"
              />
              <select
                name="type"
                value={formData.type}
                onChange={handleChange}
                className="w-full p-3 border rounded-md"
              >
                <option value="">Select Type</option>
                <option value="city">City</option>
                <option value="district">District</option>
              </select>
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                className="w-full p-3 border rounded-md"
              />
              {formData.image && (
                <p className="text-sm text-gray-500">
                  Selected: {formData.image.name}
                </p>
              )}
              <button
                type="submit"
                className="w-full bg-green-600 text-white py-2 rounded-md hover:bg-green-700"
              >
                {selectedOffer ? "Update Offer" : "Submit Offer"}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Filtered Offers List */}
      <h3 className="text-2xl font-semibold mt-10 mb-6 text-left text-gray-800">
        {filterType === "all"
          ? "All Offers"
          : `Filtered Offers: ${filterType.toUpperCase()}`}
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {filteredOffers.map((offer, index) => (
          <div
            key={index}
            className={`relative rounded-2xl border border-gray-300 p-6 shadow-lg hover:shadow-xl hover:scale-[1.03] transition-all duration-300 ${cardColors[index % cardColors.length]}`}
          >
          
                    {offer.image && (
                      <div className="flex justify-center mb-4">

                  <img
                    src={"https://gantasoft.in/cab-g/dev/admin/uploads/" + offer.image || offer.image}
                     alt={offer.title}
            className="w-24 h-24 object-contain rounded-full border"
                  />
               </div>
              )}
            <h4 className="text-2xl font-extrabold mb-3 truncate">
              {offer.title || "Untitled Offer"}
            </h4>
            <ul className="space-y-1 text-base mb-4">
              <li>
                <strong>Description:</strong> {offer.description}
              </li>
              <li>
                <strong>Price:</strong> ₹{offer.price}
              </li>
              <li>
                <strong>Type:</strong> {offer.type}
              </li>
            </ul>

            <div className="flex justify-between items-center gap-3">
              <button
                onClick={() => handleEdit(offer)}
                className="text-sm px-4 py-1 bg-yellow-500 text-white rounded hover:bg-yellow-600"
              >
                Edit
              </button>
              <button
                onClick={() => handleDelete(offer.id)}
                className="text-sm px-4 py-1 bg-red-500 text-white rounded hover:bg-red-600"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Service;
